document.addEventListener('click', function (event) {
    let element = event.target.closest('[data-delegate-click]');

    if (element !== null) {
        document.querySelector(element.dataset.delegateClick).click();
        event.preventDefault();
    }
})
